import React from "react";
import { BtnUi, Heading, DialogUi } from "~/components";
import { useSsoRedirect } from "../../hooks/useSsoRedirect";
import styles from "./JoinBonvoyPopup.module.css";

export const JoinBonvoyPopup = ({ onClose, redirectUrl = "/passions-hub" }) => {
  const ssoRedirect = useSsoRedirect(true, redirectUrl);

  const handleJoinNow = () => {
    window.open(
      "https://www.marriott.com/loyalty/member-benefits.mi",
      "_blank",
      "noopener,noreferrer",
    );
    onClose();
  };

  const handleSignIn = () => {
    ssoRedirect("passions-hub");
    onClose();
  };

  return (
    <DialogUi
      data-testid="join-bonvoy-dialog"
      onClose={onClose}
      modalStyle={styles.modal}
      modalHeaderStyle={styles.modalHeader}
      modalBodyStyle={styles.modalBody}
      modalFooterStyle={styles.modalFooter}
      closeButtonStyle={styles.closeButton}
      header={null}
      body={
        <>
          <Heading
            type="h2"
            className={styles.heading}
            text="Not a member yet? Join today."
          />
          <p className={styles.text}>
            Exclusive rates, earn points toward free nights, and more. Sign up
            today for free.
          </p>
        </>
      }
      footer={
        <div className={styles.buttonGroup}>
          <BtnUi
            data-testid="join-bonvoy-submit"
            variant="secondary"
            className={styles.joinButton}
            data-custom_click_track_value="Join Bonvoy|Join Now|internal"
            onClick={handleJoinNow}
          >
            Join Now
          </BtnUi>
          <BtnUi
            data-testid="join-bonvoy-sign-in"
            variant="secondary"
            className={styles.signInButton}
            data-custom_click_track_value="Join Bonvoy|Sign In|internal"
            onClick={handleSignIn}
          >
            Sign In
          </BtnUi>
        </div>
      }
    />
  );
};
